import { adminPermissions } from './adminPermissions';
import { orgTypes, Permission } from '@retail/auth/types';

export const superuserPermissions: Permission[] = adminPermissions
  .map(
    (perm) =>
      new Permission({
        ...perm,
        userRole: 'SUPERUSER',
      })
  )
  .concat(
    orgTypes.flatMap((roleType) => {
      return [
        new Permission({
          userRole: 'SUPERUSER',
          orgType: roleType,
          resource: 'FEATURE_TOGGLES',
          actions: ['READ'],
          appTenants: ['NO', 'SE'],
        }),
        new Permission({
          userRole: 'SUPERUSER',
          orgType: roleType,
          resource: 'PERMISSIONS',
          actions: ['READ'],
          appTenants: ['NO', 'SE'],
        }),
        new Permission({
          userRole: 'SUPERUSER',
          orgType: 'RETAIL_BRAND',
          resource: 'MEMBER_CONFIG',
          actions: ['READ'],
          appTenants: ['NO', 'SE'],
        }),
      ];
    })
  );
